import { render, staticRenderFns } from "./AsImports.vue?vue&type=template&id=70e99a48&scoped=true&"
import script from "./AsImports.vue?vue&type=script&lang=js&"
export * from "./AsImports.vue?vue&type=script&lang=js&"
import style0 from "./AsImports.vue?vue&type=style&index=0&id=70e99a48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e99a48",
  null
  
)

export default component.exports